import React from 'react';
import { InputWrapper, InputInnerLabel, StyledInput } from 'elements/forms/inputs/ProBooleanRadioInput.styles';

interface ProRadioInputProps {
  value: string;
  onSelect: (selectedValue: string) => void;
  checked: boolean;
  name: string;
  required?: boolean;
}

const ProRadioInput = (props: ProRadioInputProps): JSX.Element => {
  return (
    <InputWrapper>
      <StyledInput name={props.name} type="radio" required={props.required} checked={props.checked} onChange={() => props.onSelect(props.value)}/>
      <InputInnerLabel onClick={() => props.onSelect(props.value)}>{props.value}</InputInnerLabel>
    </InputWrapper>
  );
};

export default ProRadioInput;
